import React, { useState } from 'react';
import { toast } from 'react-toastify';
import ApiGateway from '../../helper/ApiGateway';
import ERPUtils from '../../helper/Utils';
import OtpTimer from './OtpTimer';

const OtpTimerComponent = (props) => {
  const {details, clearOTPField} = props
  const [compState, setCompState] = useState({
		emailComp: true,
		otpComp: false,
		setPassComp: false
	});
	const [LoaderActive, setLoaderActive] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [canResend, setCanResend] = useState(true);
  const [timer, setTimer] = useState(299);

  const StatusHandler = (name) => {
		var newobj = {};
		Object.keys(compState).map((el) => {
			if (el === name) {
				newobj[el] = true;
			} else {
				newobj[el] = false;
			}
			return '';
		});
		const convert = { ...newobj };
		setCompState(convert);
	};

  

  const handleResendOTP = () => {
    if (resendCount < 5) {
      setResendCount((prevCount) => prevCount + 1);
      setTimer(299);
      setCanResend(true);
      var data = {
        email: details?.Email,
        clientId: details?.clientId,
      };
      setLoaderActive(true)
      ApiGateway.post('ApplicantSecurity/resendOTP', data, (response) => {
        try {
          if (ERPUtils.isUndefinedOrNull(response.data) === false) {
            if (response.data.success === true) {
              StatusHandler('otpComp');
            } else {
              if (response.data.failureMessage !== null) {
                toast.error(response.data.failureMessage);
              } else {
                toast.error('An Error occurred, Please try again.');
              }
            }
          }
        } catch (ex) {
          setLoaderActive(false);
        } finally {   
          setLoaderActive(false);
        }
      }, 'Public');
      clearOTPField();
    } else {
      if (details.isRegistered === true) {
        
        toast.error('You have reached the maximum limit, Please register again.');
      }else{
        toast.error('You have reached the maximum limit, Try again later.');
      }
    }
  };
  
    return (
      
    <div>
      {canResend ?
      (<span>
        <OtpTimer setCanResend={setCanResend}
        resendCount={resendCount}
        setTimer={setTimer}
        timer={timer}
      /> 
      </span>):
      (<span  className='link link-primary' onClick={handleResendOTP} >
      Resend OTP 
      </span>)

      }
    </div>
  );
};

export default OtpTimerComponent;
